import classNames from 'classnames';
import {observer} from 'mobx-react';
import React, {ReactNode} from 'react';

import {useMatchMedia} from '@udemy/hooks';
import {ContentArea} from '@udemy/react-layout-components';
import {Carousel} from '@udemy/react-structure-components';

import {CompleteCourseCard} from './complete-course-card';
import styles from './course-section.module.less';

interface PropsType {
    courses: number[];
    title: string;
    description?: string;
    actionButton?: ReactNode;
    category: string;
    page: string;
}

export const CourseSection = (props: PropsType) => {
    const isMobile = useMatchMedia('mobile-max');

    return (
        <div
            id={props.category}
            className={classNames(styles['course-container'], {
                [styles['course-container-mobile']]: isMobile,
            })}
        >
            <div className={classNames(styles['title-section'])}>
                <h1 className={classNames('ud-heading-serif-xxl', styles['title'])}>
                    {props.title}
                </h1>
                {props.description && (
                    <div className={classNames('ud-text-large')}>{props.description}</div>
                )}
            </div>
            <div className={classNames(styles['course-carousel'])}>
                <ContentArea>
                    <Carousel allowScroll={!!isMobile} showPager={!isMobile}>
                        {props.courses.map((course: number, index: number) => (
                            <CompleteCourseCard
                                key={index}
                                id={course}
                                category={props.category}
                                page={props.page}
                            />
                        ))}
                    </Carousel>
                </ContentArea>
            </div>
            {props.actionButton && (
                <div className={classNames(styles['action-button'])}>{props.actionButton}</div>
            )}
        </div>
    );
};
